import globals from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    box: {
        border: 'solid 1px #ddd',
        minHeight: '614px'
    }
});
